<!-- Parents Information Form -->
<form [formGroup]="parentsInfoForm" (ngSubmit)="updateParentsInfo()">
  <div class="grid w-full">
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="relation">Relation</label>
      <p-dropdown formControlName="relation" [options]="parentRelations" optionLabel="name" optionValue="value"
        placeholder="Select Relation" appendTo="body" class="w-full" styleClass="select_type" />
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="name">Name</label>
      <input type="text" class="input_style" formControlName="name"
        placeholder="Enter parent/guardian name">
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="email">Email *</label>
      <input type="email" class="input_style" formControlName="email"
        [class.error]="parentsInfoForm.get('email')?.invalid && parentsInfoForm.get('email')?.touched"
        placeholder="Enter parent/guardian email">
      <small class="text-red-500"
        *ngIf="parentsInfoForm.get('email')?.invalid && parentsInfoForm.get('email')?.touched">
        <span *ngIf="parentsInfoForm.get('email')?.errors?.['required']">Email is required</span>
        <span *ngIf="parentsInfoForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="phone">Phone</label>
      <input type="tel" class="input_style" formControlName="phone"
        [class.error]="parentsInfoForm.get('phone')?.invalid && parentsInfoForm.get('phone')?.touched"
        placeholder="Enter parent/guardian phone number">
      <small class="text-red-500"
        *ngIf="parentsInfoForm.get('phone')?.invalid && parentsInfoForm.get('phone')?.touched">
        <span *ngIf="parentsInfoForm.get('phone')?.errors?.['pattern']">Please enter a valid phone number</span>
      </small>
    </div>
  </div>

  <div class="w-full flex align-items-center justify-content-end gap-3 pt-4">
    <p-button label="Reset Information" styleClass="reset_inf" (onClick)="resetParentsInfo()" />
    <p-button
      [label]="isEditMode ? 'Update Information' : 'Save Information'"
      styleClass="update_inf"
      [loading]="loading"
      (onClick)="updateParentsInfo()" />
  </div>
</form>
